/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import UniversalVerifierABI from './UniversalVerifier.json';
import IVerifierABI from './IVerifier.json';

export type { UniversalVerifier, IVerifier } from "./UniversalVerifier";
export * as factories from "./factories";
export { UniversalVerifier__factory } from "./factories/UniversalVerifier__factory";
export { IVerifierABI, UniversalVerifierABI };